var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingBagBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 56,
    viewBox: "0 0 62 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.01 55.13C43.1643 55.13 44.1001 54.1942 44.1001 53.04C44.1001 51.8857 43.1643 50.95 42.01 50.95C40.8558 50.95 39.92 51.8857 39.92 53.04C39.92 54.1942 40.8558 55.13 42.01 55.13Z",
    fill: "#00C9B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6 55.13C28.7543 55.13 29.69 54.1942 29.69 53.04C29.69 51.8857 28.7543 50.95 27.6 50.95C26.4457 50.95 25.51 51.8857 25.51 53.04C25.51 54.1942 26.4457 55.13 27.6 55.13Z",
    fill: "#00C9B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.61 46.1699H18.74C17.53 46.1699 16.51 45.27 16.35 44.08L11.32 16.68C11.13 15.23 12.25 13.95 13.71 13.95H57.63C59.09 13.95 60.21 15.23 60.02 16.68L54.99 44.08C54.83 45.28 53.81 46.1699 52.6 46.1699H52.61Z",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.35 16.67L9.00002 3.77997H1.83002",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.07 29.26L32.99 35.99L46.26 22.53",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2401 17.93C19.2401 8.96999 26.5301 1.67999 35.4901 1.67999C44.4501 1.67999 51.7401 8.96999 51.7401 17.93",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.41 20.74C18.78 20.74 18.19 20.49 17.74 20.05C17.29 19.6 17.05 19.01 17.05 18.38C17.05 17.08 18.11 16.01 19.42 16.01C20.73 16.01 21.79 17.07 21.79 18.38C21.79 19.69 20.73 20.75 19.42 20.75L19.41 20.74Z",
    fill: "#2E63EE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7401 20.74C51.1101 20.74 50.5201 20.49 50.0701 20.05C49.6201 19.6 49.3801 19.01 49.3801 18.38C49.3801 17.08 50.4401 16.01 51.7501 16.01C53.0601 16.01 54.1201 17.07 54.1201 18.38C54.1201 19.69 53.0601 20.75 51.7501 20.75L51.7401 20.74Z",
    fill: "#2E63EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBagBold);
export default __webpack_public_path__ + "static/media/shopping-bag-bold.73411105fbb256e12d221b224f071747.svg";
export { ForwardRef as ReactComponent };